<script>
  export default {
    name: 'power-button',

    props: {
      isOn: Boolean
    }
  }
</script>

<template>
  <div class="btn-power" :class="{on: isOn}">
    <div class="icon"></div>
  </div>
</template>

<style src="./PowerButton.scss" lang="scss" scoped></style>
